import _implicitStylesheets from "./agentforceChat.css";
import _implicitScopedStylesheets from "./agentforceChat.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  return stc0;
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-43pgp1toq4g";
tmpl.legacyStylesheetToken = "undefined-_agentforceChat";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
